import { Flex } from 'antd';

import { DescriptionWrapper, IconWrapper, TitleWrapper, Wrapper } from './QuizOption.styles';

type Props = {
  icon: string | React.ReactNode;
  title: string;
  description: string;
  onClick?: () => void;
  disabled?: boolean;
};

export const QuizOption: React.FC<Props> = ({ icon, title, description, onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      {typeof icon === 'string' ? <IconWrapper>{icon}</IconWrapper> : icon}
      <Flex vertical gap={8}>
        <TitleWrapper>{title}</TitleWrapper>
        <DescriptionWrapper>{description}</DescriptionWrapper>
      </Flex>
    </Wrapper>
  );
};
